import React, { useEffect, useState, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useCliente } from "../context/ClienteContext";

const ListagemCoordenadores = () => {
  const [coordenadores, setCoordenadores] = useState([]);
  const [filtros, setFiltros] = useState({
    nome: "",
    cpf: "",
    usuario: ""
  });

  const { parametros } = useCliente();
  const navigate = useNavigate();
  const clienteId = localStorage.getItem("cliente_id");
  const debounceTimeout = useRef(null);

  const buscarCoordenadores = async (filtrosAplicados = filtros) => {
    try {
      const queryParams = new URLSearchParams({
        cliente_id: clienteId,
        tipo: "coordenador",
        ...filtrosAplicados
      });

      const response = await fetch(`http://localhost:5000/api/usuarios?${queryParams.toString()}`);
      const data = await response.json();
      setCoordenadores(data);
    } catch (error) {
      console.error("Erro ao buscar coordenadores:", error);
      alert("Erro ao buscar coordenadores.");
    }
  };

  useEffect(() => {
    if (clienteId) {
      buscarCoordenadores();
    }
  }, [clienteId]);
  

  const handleChange = (e) => {
    const novosFiltros = { ...filtros, [e.target.name]: e.target.value };
    setFiltros(novosFiltros);

    if (debounceTimeout.current) {
      clearTimeout(debounceTimeout.current);
    }

    debounceTimeout.current = setTimeout(() => {
      buscarCoordenadores(novosFiltros);
    }, 300);
  };

  const handleLimpar = () => {
    const filtrosZerados = {
      nome: "",
      cpf: "",
      usuario: ""
    };
    setFiltros(filtrosZerados);
    buscarCoordenadores(filtrosZerados);
  };

  return (
    <div className="form-wrapper">
      <h2 className="form-title">Coordenadores Cadastrados</h2>

      <div className="filtros-cursos">
        <div className="filtros-linha-1">
          <input
            type="text"
            name="nome"
            placeholder="Filtrar por nome"
            value={filtros.nome}
            onChange={handleChange}
          />
          <input
            type="text"
            name="cpf"
            placeholder="Filtrar por CPF"
            value={filtros.cpf}
            onChange={handleChange}
          />
          <input
            type="text"
            name="usuario"
            placeholder="Filtrar por usuário"
            value={filtros.usuario}
            onChange={handleChange}
          />
        </div>

        <div className="filtros-linha-2">
          <button className="btn btn-secondary" onClick={handleLimpar}>
            Limpar Filtros
          </button>

          <button
            className="btn btn-primary"
            onClick={() => navigate(`/coordenadores/cadastro/${clienteId}`)}
            >
            Adicionar Coordenador
          </button>
        </div>
      </div>

      <table className="tabela" style={{ fontSize: "0.75rem", marginTop: "10px" }}>
        <thead
          style={{
            backgroundColor: parametros?.cor_cabecalho || "#156082",
            color: "white"
          }}
        >
          <tr>
            <th style={{ width: "30%", textAlign: "left" }}>Nome</th>
            <th style={{ width: "25%", textAlign: "left" }}>CPF</th>
            <th style={{ width: "25%", textAlign: "left" }}>Usuário</th>
            <th style={{ width: "20%", textAlign: "left" }}>Email</th>
          </tr>
        </thead>
        <tbody>
          {coordenadores.length === 0 ? (
            <tr>
              <td colSpan="4">Nenhum coordenador encontrado.</td>
            </tr>
          ) : (
            coordenadores.map((c) => (
              <tr key={c.id}>
                <td>
                  <span
                    onClick={() => navigate(`/coordenadores/${c.id}`)}
                    style={{ cursor: "pointer", color: "#007bff", textDecoration: "underline" }}
                  >
                    {c.nome_completo}
                  </span>
                </td>
                <td>{c.cpf}</td>
                <td>{c.usuario}</td>
                <td>{c.email}</td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
};

export default ListagemCoordenadores;
